import { useState } from "react";
import { Box, Button } from "@mui/material";

import DashboardRenderer from "../Dashboard/DashboardRenderer";
import {
  SALESREP_MY_PERF_LAYOUT_SCOPES,
  SALESREP_MY_PERF_PERFORMANCE_LAYOUT,
  SALESREP_MY_PERF_HCP_LAYOUT,
  SALESREP_MY_PERF_COMPETITOR_LAYOUT,
  SALESREP_MY_PERF_HCP_EXTRA_SWITCH_OPTIONS,
  SALESREP_MY_PERF_PERFORMANCE_EXTRA_SWITCH_OPTIONS,
  SALESREP_MY_PERF_SWITCH_OPTIONS,
  TYVASO_DPI_WIDGET_TYPES,
} from "../Dashboard/layouts";
import { isTyvasoProductSelection } from "../myPerformanceHelpers";

const SALESREP_TABS = [
  {
    id: "performance",
    label: "Explore My Performance",
  },
  {
    id: "hcp",
    label: "Explore HCPs",
  },
  {
    id: "competitor",
    label: "Explore Competitor Insights",
  },
];

export default function SalesRepWidgetTabs({ widgetProps, selectedProduct }) {
  const [activeTab, setActiveTab] = useState(SALESREP_TABS[0].id);
  const performanceExtras = isTyvasoProductSelection(selectedProduct)
    ? [
      ...SALESREP_MY_PERF_PERFORMANCE_EXTRA_SWITCH_OPTIONS,
      ...TYVASO_DPI_WIDGET_TYPES,
    ]
    : SALESREP_MY_PERF_PERFORMANCE_EXTRA_SWITCH_OPTIONS;

  return (
    <>
      <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap", mb: 3 }}>
        {SALESREP_TABS.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <Button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              variant={isActive ? "contained" : "outlined"}
              sx={{
                textTransform: "none",
                borderRadius: 999,
                px: 2.5,
                py: 0.9,
                fontWeight: 600,
                fontSize: 14,
                boxShadow: "none",
                borderColor: "#D0D7DE",
                color: isActive ? "#FFFFFF" : "#1F2937",
                bgcolor: isActive ? "#005A9C" : "#FFFFFF",
                "&:hover": {
                  boxShadow: "none",
                  borderColor: isActive ? "#005A9C" : "#BFC7CF",
                  bgcolor: isActive ? "#00508B" : "#F9FBFD",
                },
              }}
            >
              {tab.label}
            </Button>
          );
        })}
      </Box>

      {activeTab === "performance" && (
        <DashboardRenderer
          roleKey="SALESREP"
          widgetProps={widgetProps}
          layoutScope={SALESREP_MY_PERF_LAYOUT_SCOPES.performance}
          defaultLayoutOverride={SALESREP_MY_PERF_PERFORMANCE_LAYOUT}
          switchOptionsOverride={SALESREP_MY_PERF_SWITCH_OPTIONS.performance}
          extraSwitchOptionsOverride={performanceExtras}
        />
      )}

      {activeTab === "hcp" && (
        <DashboardRenderer
          roleKey="SALESREP"
          widgetProps={widgetProps}
          layoutScope={SALESREP_MY_PERF_LAYOUT_SCOPES.hcp}
          defaultLayoutOverride={SALESREP_MY_PERF_HCP_LAYOUT}
          switchOptionsOverride={SALESREP_MY_PERF_SWITCH_OPTIONS.hcp}
          extraSwitchOptionsOverride={SALESREP_MY_PERF_HCP_EXTRA_SWITCH_OPTIONS}
        />
      )}

      {activeTab === "competitor" && (
        <DashboardRenderer
          roleKey="SALESREP"
          widgetProps={widgetProps}
          layoutScope={SALESREP_MY_PERF_LAYOUT_SCOPES.competitor}
          defaultLayoutOverride={SALESREP_MY_PERF_COMPETITOR_LAYOUT}
          switchOptionsOverride={SALESREP_MY_PERF_SWITCH_OPTIONS.competitor}
        />
      )}
    </>
  );
}
